// extracted by mini-css-extract-plugin
export default {"logo":"logo---KSa0d"};